import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { GRNProvider, GRNContext } from "./Context/GRNContext";

import Header from "./components/Header";
import SignIn from "./Authorization/SignIn";
import ProtectedRoute from "./ProtectedRoute";
import GrnSubmission from "./components/GRNSubmission";
import GrnRecords from "./components/GrnRecords";

function HomeRoute() {
  const { isAuthenticated } = useContext(GRNContext);
  return isAuthenticated ? <Navigate to="/" replace /> : <SignIn />;
}

function AppContent() {
  return (
    <div>
      <Header />

      <Routes>
        <Route path="/login" element={<HomeRoute />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<GrnSubmission />} />
          <Route path="/records" element={<GrnRecords />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <GRNProvider>
      <AppContent />
    </GRNProvider>
  );
}